/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { Embed, EntityId } from "./data-contracts";

/**
 * @description Resolves an external URL to an oEmbed representation (title, thumbnail, HTML snippet) within the context of a space. Use this to preview or embed third-party content referenced in a space's pages. Requires the URL as a query parameter.
 * @tags space-embeds
 * @name GetEmbedByUrlInSpace
 * @summary Resolve a URL to an oEmbed object within a space
 * @request GET:/spaces/{spaceId}/embed
 * @secure
 */

// @ts-ignore
export const getEmbedByUrlInSpace: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /** URL to resolve */
    url: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Embed;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/embed",
  method: "get",
  streaming: false,
  tags: ["space-embeds"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
